import { render, staticRenderFns } from "./TaskLists.vue?vue&type=template&id=7c0c17c4"
import script from "./TaskLists.vue?vue&type=script&lang=js"
export * from "./TaskLists.vue?vue&type=script&lang=js"
import style0 from "./TaskLists.vue?vue&type=style&index=0&id=7c0c17c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports